import { render, staticRenderFns } from "./Cargos-item.vue?vue&type=template&id=5ded2871&scoped=true&lang=pug"
import script from "./Cargos-item.vue?vue&type=script&lang=js"
export * from "./Cargos-item.vue?vue&type=script&lang=js"
import style0 from "./Cargos-item.vue?vue&type=style&index=0&id=5ded2871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded2871",
  null
  
)

export default component.exports